// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__tDdZi","Container":"Footer_Container__Vz1j2","Text":"Footer_Text__CwIkc","Links":"Footer_Links__6grb-"};